module.exports = __webpack_public_path__ + "img/icon_closed_eye.354032d3.svg";